import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getColoresLego,
  deleteColorLego,
  insertColorLego,
  updateColorLego,
  getColorLegoById,
  updateRangeColoresLego,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ALL_COLORES_LEGO(action) {
  try {
    const coloresLegoData = yield call(getColoresLego, action.payload)
    if (coloresLegoData.ok) {
      yield put({
        type: actions.GET_ALL_COLORES_LEGO_SUCCEEDED,
        payload: coloresLegoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.GET_ALL_COLORES_LEGO_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_ALL_COLORES_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_COLOR_LEGO(action) {
  try {
    const deleteColorLegoData = yield call(deleteColorLego, action.payload)
    if (deleteColorLegoData.ok) {
      putMessage(messageType.SUCCESS, 'Eliminado correctamente')
      yield put({
        type: actions.DELETE_COLOR_LEGO_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar')
      put({
        type: actions.DELETE_COLOR_LEGO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar')
    yield all([
      put({
        type: actions.DELETE_COLOR_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_COLOR_LEGO(action) {
  try {
    const colorLegoData = yield call(insertColorLego, action.payload)
    if (colorLegoData.ok) {
      putMessage(messageType.SUCCESS, 'Creado correctamente')
      yield put({
        type: actions.INSERT_COLOR_LEGO_SUCCEEDED,
        payload: colorLegoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear')
      yield put({
        type: actions.INSERT_COLOR_LEGO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear')
    yield all([
      put({
        type: actions.INSERT_COLOR_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_COLOR_LEGO(action) {
  try {
    const colorLegoData = yield call(updateColorLego, action.payload)
    if (colorLegoData.ok) {
      putMessage(messageType.SUCCESS, 'Modificado correctamente')
      yield put({
        type: actions.UPDATE_COLOR_LEGO_SUCCEEDED,
        payload: colorLegoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar')
      yield put({
        type: actions.UPDATE_COLOR_LEGO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar')
    yield all([
      put({
        type: actions.UPDATE_COLOR_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_RANGE_COLORES_LEGO(action) {
  try {
    const colorLegoData = yield call(updateRangeColoresLego, action.payload)
    if (colorLegoData.ok) {
      putMessage(messageType.SUCCESS, 'Modificado correctamente')
      yield put({
        type: actions.UPDATE_RANGE_COLORES_LEGO_SUCCEEDED,
        payload: colorLegoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar')
      yield put({
        type: actions.UPDATE_RANGE_COLORES_LEGO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar')
    yield all([
      put({
        type: actions.UPDATE_COLOR_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_COLOR_LEGO_BY_ID(action) {
  try {
    const colorLegoData = yield call(getColorLegoById, action.payload)
    if (colorLegoData.ok) {
      yield put({
        type: actions.GET_BY_ID_COLOR_LEGO_SUCCEEDED,
        payload: colorLegoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.GET_BY_ID_COLOR_LEGO_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_BY_ID_COLOR_LEGO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_ALL_COLORES_LEGO_REQUESTED, GET_ALL_COLORES_LEGO),
    takeEvery(actions.GET_BY_ID_COLOR_LEGO_REQUESTED, GET_COLOR_LEGO_BY_ID),
    takeEvery(actions.INSERT_COLOR_LEGO_REQUESTED, INSERT_COLOR_LEGO),
    takeEvery(actions.UPDATE_COLOR_LEGO_REQUESTED, UPDATE_COLOR_LEGO),
    takeEvery(actions.UPDATE_RANGE_COLORES_LEGO_REQUESTED, UPDATE_RANGE_COLORES_LEGO),
    takeEvery(actions.DELETE_COLOR_LEGO_REQUESTED, DELETE_COLOR_LEGO),
  ])
}
